// Reducer for tracker actions

import * as ActionTypes from '../constants/action_types'
import {
  trackerList,
  trackerPlanDetails,
  trackerTimelineView,
  trackerPrimaryEntity,
  trackerTeasersAndTrailers,
  trackerpageWhatsNew,
  DefaultTrackerListState,
  trackerpageWordCloud,
  trackerAverageBenchMarkPlanDetails,
  trackerAverageBenchMarkTimelineView,
  trackerSingleTrackerPlanDetails,
  trackerSingleTrackerTimelineView
} from './trackerModule_reducer'

export const DefaultTrackerState = {
  list: { ...DefaultTrackerListState },
  byId: {},
  selectedTrackerEntity: null,
  trackerEntityType: null
}

export const tracker = (state = DefaultTrackerState, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_TRACKER:
    case ActionTypes.RECEIVE_TRACKER:
    case ActionTypes.REQUEST_TRACKER_FAILURE:
    case ActionTypes.INVALIDATE_TRACKER:
      return {
        ...state,
        list: trackerList(state.list, action)
      }
      case ActionTypes.TRACKER_SELECTED_ENTITY:
        if (action.trackerId) {
          return {
            ...state,
              selectedTrackerEntity: action.trackerEntityId,
              trackerEntityType: action.trackerEntityType,
            byId: {
              ...state.byId,
              [action.trackerId]: trackerById(state.byId[action.trackerId], action)
            }
          }
        } else {
          console.warn('Tracker action fired without a tracker id:', action)
          return state
        }
      case ActionTypes.SINGLE_TRACKER_SELECTED_ENTITY:
        if (action.trackerId) {
          return {
            ...state,
              selectedSingleTrackerEntity: action.trackerEntityId,
              trackerEntityType: action.trackerEntityType,
            byId: {
              ...state.byId,
              [action.trackerId]: trackerById(state.byId[action.trackerId], action)
            }
          }
        } else {
          console.warn('Tracker action fired without a tracker id:', action)
          return state
        }
      case ActionTypes.REQUEST_TRACKER_WHATS_NEW:
      case ActionTypes.RECEIVE_TRACKER_WHATS_NEW:
      case ActionTypes.REQUEST_TRACKER_WHATS_NEW_FAILURE:
      case ActionTypes.INVALIDATE_TRACKER_WHATS_NEW:
      case ActionTypes.REQUEST_TRACKER_PLAN:
      case ActionTypes.RECEIVE_TRACKER_PLAN:
      case ActionTypes.REQUEST_TRACKER_PLAN_FAILURE:
      case ActionTypes.REQUEST_AVERAGE_BENCH_MARK_TRACKER_PLAN:
      case ActionTypes.RECEIVE_AVERAGE_BENCH_MARK_TRACKER_PLAN:
      case ActionTypes.REQUEST_AVERAGE_BENCH_MARK_TRACKER_PLAN_FAILURE:
      case ActionTypes.REQUEST_SINGLE_TRACKER_PLAN:
      case ActionTypes.RECEIVE_SINGLE_TRACKER_PLAN:
      case ActionTypes.REQUEST_SINGLE_TRACKER_PLAN_FAILURE:
      case ActionTypes.REQUEST_TRACKER_TIMELINE_VIEW:
      case ActionTypes.RECEIVE_TRACKER_TIMELINE_VIEW:
      case ActionTypes.REQUEST_TRACKER_TIMELINE_VIEW_FAILURE:
      case ActionTypes.REQUEST_AVERAGE_BENCH_MARK_TRACKER_TIMELINE_VIEW:
      case ActionTypes.RECEIVE_AVERAGE_BENCH_MARK_TRACKER_TIMELINE_VIEW:
      case ActionTypes.REQUEST_AVERAGE_BENCH_MARK_TRACKER_TIMELINE_VIEW_FAILURE:
      case ActionTypes.REQUEST_SINGLE_TRACKER_TIMELINE_VIEW:
      case ActionTypes.RECEIVE_SINGLE_TRACKER_TIMELINE_VIEW:
      case ActionTypes.REQUEST_SINGLE_TRACKER_TIMELINE_VIEW_FAILURE:
      case ActionTypes.REQUEST_TRACKER_PRIMARY_ENTITY_DETAILS:
      case ActionTypes.RECEIVE_TRACKER_PRIMARY_ENTITY_DETAILS:
      case ActionTypes.REQUEST_TRACKER_PRIMARY_ENTITY_FAILURE:
      case ActionTypes.REQUEST_TRACKER_TEASERS_TRAILERS:
      case ActionTypes.RECEIVE_TRACKER_TEASERS_TRAILERS:
      case ActionTypes.REQUEST_TRACKER_TEASERS_TRAILERS_FAILURE:
      case ActionTypes.INVALIDATE_TRACKER_TEASERS_TRAILERS:
      case ActionTypes.REQUEST_TRACKER_WORD_CLOUD:
      case ActionTypes.RECEIVE_TRACKER_WORD_CLOUD:
      case ActionTypes.REQUEST_TRACKER_WORD_CLOUD_FAILURE:
      case ActionTypes.INVALIDATE_TRACKER_WORD_CLOUD:
        if (action.trackerId) {
          return {
            ...state,
            byId: {
              ...state.byId,
              [action.trackerId]: trackerById(state.byId[action.trackerId], action)
            }
          }
        } else {
          console.warn('Tracker action fired without a tracker id:', action)
          return state
        }
    default:
      return state
    }
}

export const trackerEntityById = (state = {}, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_TRACKER_TEASERS_TRAILERS:
    case ActionTypes.RECEIVE_TRACKER_TEASERS_TRAILERS:
    case ActionTypes.REQUEST_TRACKER_TEASERS_TRAILERS_FAILURE:
    case ActionTypes.INVALIDATE_TRACKER_TEASERS_TRAILERS:
      return {
        ...state,
        teasersAndTrailers: trackerTeasersAndTrailers(state.teasersAndTrailers, action)
      }
    case ActionTypes.REQUEST_SINGLE_TRACKER_PLAN:
    case ActionTypes.RECEIVE_SINGLE_TRACKER_PLAN:
    case ActionTypes.REQUEST_SINGLE_TRACKER_PLAN_FAILURE:
      return {
        ...state,
        singleTrackerPlanDetails: trackerSingleTrackerPlanDetails(state.singleTrackerPlanDetails, action)
      }
    case ActionTypes.REQUEST_SINGLE_TRACKER_TIMELINE_VIEW:
    case ActionTypes.RECEIVE_SINGLE_TRACKER_TIMELINE_VIEW:
    case ActionTypes.REQUEST_SINGLE_TRACKER_TIMELINE_VIEW_FAILURE:
      return {
        ...state,
        singleTrackerTimelineView: trackerSingleTrackerTimelineView(state.singleTrackerTimelineView, action)
      }
    case ActionTypes.REQUEST_TRACKER_WHATS_NEW:
    case ActionTypes.RECEIVE_TRACKER_WHATS_NEW:
    case ActionTypes.REQUEST_TRACKER_WHATS_NEW_FAILURE:
    case ActionTypes.INVALIDATE_TRACKER_WHATS_NEW:
      return {
        ...state,
        whatsNew: trackerpageWhatsNew(state.whatsNew, action)
      }
    case ActionTypes.REQUEST_TRACKER_WORD_CLOUD:
    case ActionTypes.RECEIVE_TRACKER_WORD_CLOUD:
    case ActionTypes.REQUEST_TRACKER_WORD_CLOUD_FAILURE:
    case ActionTypes.INVALIDATE_TRACKER_WORD_CLOUD:
      return {
        ...state,
        wordCloud: trackerpageWordCloud(state.wordCloud, action)
      }
    default:
      return state
  }
}

export const trackerById = (state = {}, action) => {
  switch (action.type) {
    case ActionTypes.TRACKER_SELECTED_ENTITY:
      return {
        ...state,
        selectedTrackerEntity: action.trackerEntityId
      }
    case ActionTypes.SINGLE_TRACKER_SELECTED_ENTITY:
      return {
        ...state,
        selectedSingleTrackerEntity: action.trackerEntityId
      }
    case ActionTypes.REQUEST_TRACKER_PLAN:
    case ActionTypes.RECEIVE_TRACKER_PLAN:
    case ActionTypes.REQUEST_TRACKER_PLAN_FAILURE:
      return {
        ...state,
       planDetails: trackerPlanDetails(state.details, action)
      }
    case ActionTypes.REQUEST_AVERAGE_BENCH_MARK_TRACKER_PLAN:
    case ActionTypes.RECEIVE_AVERAGE_BENCH_MARK_TRACKER_PLAN:
    case ActionTypes.REQUEST_AVERAGE_BENCH_MARK_TRACKER_PLAN_FAILURE:
      return {
        ...state,
        averagePlanDetails: trackerAverageBenchMarkPlanDetails(state.details, action)
      }
    case ActionTypes.REQUEST_SINGLE_TRACKER_PLAN:
    case ActionTypes.RECEIVE_SINGLE_TRACKER_PLAN:
    case ActionTypes.REQUEST_SINGLE_TRACKER_PLAN_FAILURE:
      if (action.response) {
        const nonDefaultbenchmarks = (state.planDetails.details && state.planDetails.details.non_defaultbenchmarks && state.planDetails.details.non_defaultbenchmarks.length > 0) ? state.planDetails.details.non_defaultbenchmarks : []
        nonDefaultbenchmarks.map(e => {
          if (e.tracker_entity_id === action.entityId) {
            e.metrics = action.response.tracker.metrics
          }
        })
        return {
          ...state,
          planDetails: {
            ...state.planDetails,
            details: {
              ...state.planDetails.details,
              non_defaultbenchmarks: nonDefaultbenchmarks
            }
          },
          byTrackerEntityId: {
            ...state.byTrackerEntityId,
            [action.entityId]: trackerEntityById(state.byTrackerEntityId && state.byTrackerEntityId[action.entityId], action)
          }
        }
      }
      return {
        ...state,
        byTrackerEntityId: {
          ...state.byTrackerEntityId,
          [action.entityId]: trackerEntityById(state.byTrackerEntityId && state.byTrackerEntityId[action.entityId], action)
        }
      }
    case ActionTypes.REQUEST_TRACKER_TIMELINE_VIEW:
    case ActionTypes.RECEIVE_TRACKER_TIMELINE_VIEW:
    case ActionTypes.REQUEST_TRACKER_TIMELINE_VIEW_FAILURE:
      return {
        ...state,
        timelineView: trackerTimelineView(state.details, action)
      }
    case ActionTypes.REQUEST_AVERAGE_BENCH_MARK_TRACKER_TIMELINE_VIEW:
    case ActionTypes.RECEIVE_AVERAGE_BENCH_MARK_TRACKER_TIMELINE_VIEW:
    case ActionTypes.REQUEST_AVERAGE_BENCH_MARK_TRACKER_TIMELINE_VIEW_FAILURE:
      return {
        ...state,
        averageTimelineView: trackerAverageBenchMarkTimelineView(state.details, action)
      }
    case ActionTypes.REQUEST_SINGLE_TRACKER_TIMELINE_VIEW:
    case ActionTypes.RECEIVE_SINGLE_TRACKER_TIMELINE_VIEW:
    case ActionTypes.REQUEST_SINGLE_TRACKER_TIMELINE_VIEW_FAILURE:
      if (action.response) {
        const nonDefaultbenchmarks = (state.timelineView.details && state.timelineView.details.non_defaultbenchmarks && state.timelineView.details.non_defaultbenchmarks.length > 0) ? state.timelineView.details.non_defaultbenchmarks : []
        nonDefaultbenchmarks.map(e => {
          if (e.tracker_entity_id === action.entityId) {
            e.metrics = action.response.tracker.metrics
          }
        })
        return {
          ...state,
          timelineView: {
            ...state.timelineView,
            details: {
              ...state.timelineView.details,
              non_defaultbenchmarks: nonDefaultbenchmarks
            }
          },
          byTrackerEntityId: {
            ...state.byTrackerEntityId,
            [action.entityId]: trackerEntityById(state.byTrackerEntityId && state.byTrackerEntityId[action.entityId], action)
          }
        }
      }
      return {
        ...state,
        byTrackerEntityId: {
          ...state.byTrackerEntityId,
          [action.entityId]: trackerEntityById(state.byTrackerEntityId && state.byTrackerEntityId[action.entityId], action)
        }
      }
    case ActionTypes.REQUEST_TRACKER_PRIMARY_ENTITY_DETAILS:
    case ActionTypes.RECEIVE_TRACKER_PRIMARY_ENTITY_DETAILS:
    case ActionTypes.REQUEST_TRACKER_PRIMARY_ENTITY_FAILURE:
      return {
        ...state,
        primaryEntity: trackerPrimaryEntity(state.details, action)
      }
    case ActionTypes.REQUEST_TRACKER_TEASERS_TRAILERS:
    case ActionTypes.RECEIVE_TRACKER_TEASERS_TRAILERS:
    case ActionTypes.REQUEST_TRACKER_TEASERS_TRAILERS_FAILURE:
    case ActionTypes.INVALIDATE_TRACKER_TEASERS_TRAILERS:
      return {
        ...state,
        byTrackerEntityId: {
          ...state.byTrackerEntityId,
          [action.trackerEntityId]: trackerEntityById(state.byTrackerEntityId && state.byTrackerEntityId[action.trackerEntityId], action)
        }
        //teasersAndTrailers: trackerTeasersAndTrailers(state.details, action)
      }
    case ActionTypes.REQUEST_TRACKER_WHATS_NEW:
    case ActionTypes.RECEIVE_TRACKER_WHATS_NEW:
    case ActionTypes.REQUEST_TRACKER_WHATS_NEW_FAILURE:
    case ActionTypes.INVALIDATE_TRACKER_WHATS_NEW:
      return {
        ...state,
        byTrackerEntityId: {
          ...state.byTrackerEntityId,
          [action.trackerEntityId]: trackerEntityById(state.byTrackerEntityId && state.byTrackerEntityId[action.trackerEntityId], action)
        }
        //whatsNew: trackerpageWhatsNew(state.details, action)
      }
    case ActionTypes.REQUEST_TRACKER_WORD_CLOUD:
    case ActionTypes.RECEIVE_TRACKER_WORD_CLOUD:
    case ActionTypes.REQUEST_TRACKER_WORD_CLOUD_FAILURE:
    case ActionTypes.INVALIDATE_TRACKER_WORD_CLOUD:
      return {
        ...state,
        byTrackerEntityId: {
          ...state.byTrackerEntityId,
          [action.entityId]: trackerEntityById(state.byTrackerEntityId && state.byTrackerEntityId[action.entityId], action)
          //[action.entityId]: trackerEntityById(state.wordCloud, action)
        }
      }
    default:
      return state
  }
}